import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { cfpBaseUrl } from '../../network/urls';

const initialState = {
    pageNumber: 1,
    pageSize: 20,
    officeCode: '',
    officeLevel: '',
    totalRecords: null,
    totalPages: null,
    data: [],
    isLoading: false,
    error: null
}

export const actionableNormal = createAsyncThunk(
    'actionableNormal/actionableNormal',
    async ({ pageNumber, pageSize }, { rejectWithValue, getState }) => {
        try {
            const { auth } = getState();
            const { token, code, hierarchy } = auth;

            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);

            const formdata = new FormData();
            formdata.append("pageNumber", pageNumber);
            formdata.append("pageSize", pageSize);
            formdata.append("officeCode", code);
            formdata.append("officeLevel", hierarchy);
            formdata.append("overDueFlag", 0);

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
            };

            const response = await fetch(cfpBaseUrl + 'comman/getAllActionAbleFiles', requestOptions);

            const data = await response.json();

            if (response.ok && data.status !== '200') {
                throw new Error(data.message || 'Actionable API issue!');
            }

            if (!response.ok) {
                throw new Error(data.message || 'Actionable API issue!');
            }
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const actionableNormalSlice = createSlice({
    name: 'actionableNormalItems',
    initialState,
    reducers: {
        nextPage(state) {
            state.pageNumber += 1;
        },
        previousPage(state) {
            if (state.pageNumber > 1) {
                state.pageNumber -= 1;
            }
        },
        firstPage(state) {
            state.pageNumber = 1;
        },
        lastPage(state, action) {
            state.pageNumber = action.payload;
        },
        resetState: (state) => {
            state.pageNumber = 1
            state.pageSize = 20
            state.officeCode = ''
            state.officeLevel = ''
            state.totalRecords = null
            state.totalPages = null
            state.data = []
            state.isLoading = false
            state.error = null
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(actionableNormal.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(actionableNormal.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.data) {
                    state.data = action.payload.data;
                } else {
                    state.data = [];
                }
                if (action.payload.totalPages) {
                    state.totalPages = action.payload.totalPages;
                } else {
                    state.totalPages = 1;
                }
                state.totalRecords = action.payload.totalRecords;
                state.error = null;
            })
            .addCase(actionableNormal.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { nextPage, previousPage, firstPage, lastPage, resetState } = actionableNormalSlice.actions;
export default actionableNormalSlice.reducer;